/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Input, styled } from '@attentive-platform/stem-ui';
import { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { CornerArrowIcon } from '../Assets/CornerArrowIcon';
import { CircularAddIcon } from '../Assets/CircularAddIcon';
import {
  addChecklistLink,
  addNewScopeText,
  errorText,
  existingScopeItem,
  markCompleted,
  markReviewed,
  noScopeText,
  styledFlex,
  styledFlexForCheckList,
  styledFlexForCheckBox
} from './styles';
import { EstimatorType } from './types';
import { CheckFillIcon } from '../Assets/CheckFillIcon';
import { CheckMarkIcon } from '../Assets/CheckMarkIcon';
import { Checkbox } from '../Checkbox';
import { AssignmentState, useScopeStore } from './useScopeChange';

const StyledInput = styled(Input)(() => ({
  flexGrow: 1,
  '& .MuiInputBase-root': {
    height: '1.625rem'
  }
}));

const CompletedItem = () => (
  <div className={markCompleted}>
    <CheckMarkIcon /> QC
  </div>
);

const ReviewedItem = () => (
  <div className={markReviewed}>
    <CheckMarkIcon /> QA
  </div>
);

const NoScopeText = () => (
  <div className={noScopeText} style={{ color: 'var(--color-neutral-70)' }}>
    No checklist created yet
  </div>
);

const AddScopeRow = ({ onAddRow, isError }: { onAddRow: (val: string) => void; isError: boolean }) => {
  const [value, setValue] = useState('');

  return (
    <div className={styledFlex}>
      <StyledInput value={value} onChange={e => setValue(e.target.value)} error={isError} />
      <CheckFillIcon
        onClick={() => {
          if (value) onAddRow(value);
        }}
      />
    </div>
  );
};

export const Checklist = ({
  isCurrentUser,
  userPersona,
  scope,
  tradeId,
  assignmentId
}: {
  isCurrentUser: boolean;
  userPersona?: EstimatorType;
  scope: AssignmentState['scope'];
  tradeId: string;
  assignmentId: string;
}) => {
  const { addScopeItem, updateScopeItem } = useScopeStore(
    useShallow(state => ({ addScopeItem: state.addScopeItem, updateScopeItem: state.updateScopeItem }))
  );
  const [newScope, setNewScope] = useState<string | null>(null);
  const [isDuplicateItem, setIsDuplicateItem] = useState(false);

  const onAddScope = (val: string) => {
    if (scope.find(item => item.task.toLowerCase() === val.toLowerCase())) {
      setIsDuplicateItem(true);
    } else {
      addScopeItem(tradeId, assignmentId, val);
      setIsDuplicateItem(false);
      setNewScope(null);
    }
  };

  return (
    <>
      {isCurrentUser && (
        <div className={addChecklistLink} onClick={() => setNewScope('')}>
          <CircularAddIcon />
          <div className={addNewScopeText}>Add new checklist item</div>
        </div>
      )}
      {typeof newScope === 'string' && (
        <div>
          <AddScopeRow onAddRow={onAddScope} isError={isDuplicateItem} />
          {isDuplicateItem && (
            <span className={`${existingScopeItem} ${errorText}`}>Cannot create duplicate scope items</span>
          )}
        </div>
      )}
      {typeof newScope !== 'string' && !scope.length && <NoScopeText />}
      {scope.map((item, i) => (
        <div className={existingScopeItem}>
          <CornerArrowIcon />
          <div className={styledFlexForCheckList}>{item.task}</div>
          <div className={styledFlexForCheckBox}>
            {userPersona === EstimatorType.QUALITY_ASSURANCE && item.completed && !item.reviewed && (
              <Checkbox
                checked={item.reviewed}
                className='checkbox'
                onChange={e => {
                  updateScopeItem(tradeId, assignmentId, i, {
                    ...item,
                    reviewed: (e.target as HTMLInputElement).checked
                  });
                }}
              />
            )}
          </div>
          <div className={styledFlexForCheckBox}>
            {item.completed && !item.reviewed && <CompletedItem />}
            {item.reviewed && <ReviewedItem />}
            {isCurrentUser && !item.completed && !item.reviewed && (
              <Checkbox
                checked={item.completed}
                className='checkbox'
                onChange={e => {
                  updateScopeItem(tradeId, assignmentId, i, {
                    ...item,
                    completed: (e.target as HTMLInputElement).checked
                  });
                }}
              />
            )}
          </div>
        </div>
      ))}
    </>
  );
};
